import { ChatEdits } from "@/components/ChatEdits"

export function ChatEditsPage() {
  return <ChatEdits />
}
